// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Admin_headnig {
  font-size: 1.5em;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
  text-align: center;
  margin-top: 15px;
}

.Admin_headnig2 {
  font-size: 1.2em;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
  text-align: center;
  margin-top: 15px;
}
.Admin_headnig3 {
  font-size: 1.1em;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
  text-align: center;
  margin-top: 15px;
}
.Admin_headnig4 {
  font-size: 1em;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
  text-align: center;
  margin-top: 15px;
}
.Admin_headnig5 {
  font-size: 0.9em;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
  text-align: center;
  margin-top: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/Admin/admin.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".Admin_headnig {\n  font-size: 1.5em;\n  font-weight: bold;\n  color: #333;\n  margin-bottom: 10px;\n  text-align: center;\n  margin-top: 15px;\n}\n\n.Admin_headnig2 {\n  font-size: 1.2em;\n  font-weight: bold;\n  color: #333;\n  margin-bottom: 10px;\n  text-align: center;\n  margin-top: 15px;\n}\n.Admin_headnig3 {\n  font-size: 1.1em;\n  font-weight: bold;\n  color: #333;\n  margin-bottom: 10px;\n  text-align: center;\n  margin-top: 15px;\n}\n.Admin_headnig4 {\n  font-size: 1em;\n  font-weight: bold;\n  color: #333;\n  margin-bottom: 10px;\n  text-align: center;\n  margin-top: 15px;\n}\n.Admin_headnig5 {\n  font-size: 0.9em;\n  font-weight: bold;\n  color: #333;\n  margin-bottom: 10px;\n  text-align: center;\n  margin-top: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
